<template>
  <div id="datatable" class="d-flex flex-column">
    <el-table
      :row-class-name="rowClassName"
      ref="datatable"
      layout="table"
      class="attendee-list"
      :data="filterSearchData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="35"
        v-if="displaySelection"
      ></el-table-column>
      <el-table-column type="index" width="35"></el-table-column>
      <el-table-column
        name="fullname"
        :prop="columns[0].field"
        :label="columns[0].title"
        :sortable="columns[0].sortable"
        :key="columns[0].title"
      >
      </el-table-column>
      <el-table-column
        name="mobileNumber"
        width="120"
        :prop="columns[1].field"
        :label="columns[1].title"
        :sortable="columns[1].sortable"
        :key="columns[1].title"
      >
      </el-table-column>
      <el-table-column
        name="email"
        :prop="columns[2].field"
        :label="columns[2].title"
        :sortable="columns[2].sortable"
        :key="columns[2].title"
      >
      </el-table-column>
      <el-table-column
        name="projectCode"
        :prop="columns[8].field"
        :label="columns[8].title"
        :sortable="columns[8].sortable"
        :key="columns[8].title"
      >
        <template slot-scope="scope">
          <pre>
            {{
              scope.row.projectCode
                ? scope.row.projectCode.split(" & ").join("\n")
                : "OTHER"
            }}
          </pre>
        </template>
      </el-table-column>
      <el-table-column
        name="createdAt"
        width="160"
        :prop="columns[3].field"
        :label="columns[3].title"
        :sortable="columns[3].sortable"
        :key="columns[3].title"
      >
        <template slot-scope="scope">
          {{ scope.row.createdAt | moment-full }}
        </template>
      </el-table-column>
      <el-table-column
        name="code"
        width="110"
        :prop="columns[4].field"
        :label="columns[4].title"
        :sortable="columns[4].sortable"
        :key="columns[4].title"
        v-if="activeTab !== 'redeemList'"
      >
      </el-table-column>
      <el-table-column
        name="type"
        width="100"
        :prop="columns[5].field"
        :label="columns[5].title"
        :sortable="columns[5].sortable"
        :key="columns[5].title"
        v-if="activeTab === 'redeemList'"
      >
        <template slot-scope="scope">
          <span>{{
            $t(`feature.attendance.labels.${scope.row.type.toLowerCase()}`)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        name="activateDate-register"
        width="110"
        :prop="columns[6].field"
        :label="columns[6].title"
        :sortable="columns[6].sortable"
        :key="columns[6].title"
        v-if="activeTab === 'usageList' && showUseCodeButton()"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.activateDate">
            <el-popover trigger="hover" placement="top">
              <p>ใช้เมื่อ: {{ scope.row.activateDate | moment-full }}</p>
              <span slot="reference" class="name-wrapper text-green-vivid">
                <i class="fas fa-check-circle"></i>
              </span>
            </el-popover>
          </div>
          <div
            v-else-if="!$isCallCenter && scope.row.code && displayScanButton"
          >
            <button
              class="sc-btn sc-btn-sm sc-btn-outline w-auto"
              @click="setRequestCode(scope.row)"
            >
              ใช้รหัส
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        name="activateDate-immediate"
        width="110"
        :prop="columns[6].field"
        :label="columns[6].title"
        :sortable="columns[6].sortable"
        :key="columns[6].title"
        v-if="activeTab === 'usageList' && !showUseCodeButton()"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.activateDate">
            <el-popover trigger="hover" placement="top">
              <p>ใช้เมื่อ: {{ scope.row.activateDate | moment-full }}</p>
              <span slot="reference" class="name-wrapper text-green-vivid">
                <i class="fas fa-check-circle"></i>
              </span>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        name="ratingScore"
        width="110"
        :prop="columns[7].field"
        :label="columns[7].title"
        :sortable="columns[7].sortable"
        :key="columns[7].title"
        v-if="activeTab === 'usageList'"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.ratingScore > 0">
            <el-popover trigger="hover" placement="top">
              <p>คะแนน: {{ scope.row.ratingScore }}</p>
              <p>ความคิดเห็น: {{ scope.row.ratingNote || "-" }}</p>
              <p>เมื่อ: {{ scope.row.ratingDate | moment-full }}</p>
              <span slot="reference" class="name-wrapper text-green-vivid">
                <i class="fas fa-check-circle"></i>
              </span>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <div slot="empty">ยังไม่พบข้อมูล</div>
    </el-table>
    <div class="summary-bar">
      <div class="d-flex flex-row">
        <div class="summary-items mr-auto">
          <div class="item" v-show="activeTab === 'redeemList'">
            <small>จำนวนสิทธิ์</small>
            <label>
              {{ privilege.quota || "-" }}
            </label>
          </div>
          <div class="item" v-show="activeTab === 'redeemList'">
            <small>สิทธิ์สำรอง</small>
            <label>
              {{ privilege.totalReserve || "-" }}
            </label>
          </div>
          <div
            class="item"
            v-show="selection.length > 0 && activeTab === 'redeemList'"
          >
            <small>เลือกแล้ว</small>
            <label class="text-orange">
              {{ selection.length || "-" }}
            </label>
          </div>
          <div
            v-if="!$isCallCenter"
            class="item"
            v-show="selection.length > 0 && activeTab === 'redeemList'"
          >
            <button
              class="sc-btn sc-btn-opaque w-auto"
              @click="dialogs.pickSelectionDialog.isShow = true"
            >
              {{ $t(`button.${pickMethod}`) }}เป็นผู้โชคดี
            </button>
          </div>
          <div class="item" v-if="!$isCallCenter && displayPublishButton">
            <button
              class="sc-btn sc-btn-opaque w-auto disabled"
              @click="dialogs.sendNotificationDialog.isShow = true"
            >
              ประกาศผลไปยังผู้โชคดี
            </button>
          </div>
          <div class="item" v-if="displayScanButton">
            <button class="sc-btn sc-btn-opaque w-auto" @click="openScanner">
              สแกนรหัส
            </button>
          </div>
        </div>
        <div class="summary-items button-wrapper">
          <!-- <button class="sc-btn sc-btn-opaque w-auto" v-show="activeTab === 'usageList' && this.rating && !this.rating.isSent" @click="dialogs.sendRatingDialog.isShow = true">ส่งแบบประเมิน</button> -->
          <button
            class="sc-btn sc-btn-outline w-auto"
            v-show="activeTab !== 'usageList' && this.data.length > 0"
            @click="exportCode"
          >
            นำออกรหัส
          </button>
          <button
            class="sc-btn sc-btn-outline w-auto"
            v-show="this.data.length > 0"
            @click="exportList"
          >
            นำออกรายชื่อ
          </button>
        </div>
      </div>
    </div>
    <confirm
      name="pickSelectionDialog"
      v-show="dialogs.pickSelectionDialog.isShow"
      @confirm="dialogs.pickSelectionDialog.confirm"
      :data="dialogs.pickSelectionDialog.data"
      :isHTML="dialogs.pickSelectionDialog.isHTML"
    >
    </confirm>
    <confirm
      name="useCodeDialog"
      v-show="dialogs.useCodeDialog.isShow"
      @confirm="dialogs.useCodeDialog.confirm"
      :data="dialogs.useCodeDialog.data"
      :isHTML="dialogs.useCodeDialog.isHTML"
    >
    </confirm>
    <confirm
      name="sendNotificationDialog"
      v-show="dialogs.sendNotificationDialog.isShow"
      @confirm="dialogs.sendNotificationDialog.confirm"
      :data="dialogs.sendNotificationDialog.data"
    >
    </confirm>
    <confirm
      name="sendRatingDialog"
      v-show="dialogs.sendRatingDialog.isShow"
      @confirm="dialogs.sendRatingDialog.confirm"
      :data="dialogs.sendRatingDialog.data"
      :isHTML="dialogs.generalDialog.isHTML"
    >
    </confirm>
    <confirm
      name="generalDialog"
      v-show="dialogs.generalDialog.isShow"
      @confirm="dialogs.generalDialog.isShow = false"
      :data="dialogs.generalDialog.data"
      :isHTML="dialogs.generalDialog.isHTML"
    >
    </confirm>
    <barcode
      @detect="updateCode"
      @close="showScanner = false"
      v-if="showScanner"
    ></barcode>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { Table, TableColumn, Popover, Checkbox } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { PRIVILEGE, USER_PRIVILEGE_REGISTER } from "@/config/enums";
import BarcodeScanner from "@/components/helper/BarcodeScanner";

export default {
  props: ["articleId", "activeTab", "searchText", "showOnlySelected"],
  components: {
    "el-table": Table,
    "el-table-column": TableColumn,
    "el-popover": Popover,
    barcode: BarcodeScanner,
    "el-checkbox": Checkbox
  },
  data() {
    return {
      article: {},
      privilege: {},
      preferredFormat: null,
      columns: [
        { title: "ชื่อ-นามสกุล", field: "fullname", sortable: true },
        { title: "หมายเลขติดต่อ", field: "registeredMobileNumber" },
        { title: "อีเมล", field: "email", sortable: true },
        { title: "วัน/เวลาที่ร่วมสนุก", field: "createdAt", sortable: true },
        { title: "รหัสที่ได้รับ", field: "code", sortable: true },
        { title: "สิทธิ์", field: "type", sortable: true },
        { title: "สถานะรหัส", field: "activateDate", sortable: true },
        { title: "การประเมิน", field: "reviewScore", sortable: true },
        {
          title: "โครงการ / บ้านเลขที่ / Role",
          field: "projectCode",
          sortable: false
        }
      ],
      data: [],
      selection: [],
      rating: {},
      dialogs: {
        pickSelectionDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "ยืนยันการเลือกผู้โชคดี",
            detail:
              "คุณยืนยันการเลือกรายชื่อนี้ เป็นรายชื่อผู้โชคดีใช่หรือไม่?<br>เมื่อกดยืนยัน คุณจะไม่สามารถเลือกเพิ่มเติมหรือแก้ไขได้อีก",
            buttonCancel: "ยกเลิก",
            buttonSubmit: "ยืนยัน"
          },
          confirm: this.pickSelection
        },
        useCodeDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "ยืนยันการใช้งานรหัส",
            detail: "<p>ทดสอบ</p>",
            buttonCancel: "ยกเลิก",
            buttonSubmit: "ใช้งาน"
          },
          confirm: this.useCodeRequest,
          picked: null
        },
        sendNotificationDialog: {
          isShow: false,
          data: {
            title: "ยืนยันการแจ้งผล",
            detail: "คุณต้องการยืนยันการแจ้งผลไปหาผู้โชคดีใช่หรือไม่",
            buttonCancel: "ยกเลิก",
            buttonSubmit: "ยืนยัน"
          },
          confirm: this.sendNotification
        },
        sendRatingDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "ยืนยันการส่งแบบประเมิน",
            detail:
              "การส่งแบบประเมินทำได้เพียง 1 ครั้ง<br>คุณต้องการส่งแบบประเมินไปยังผู้โชคดี ใช่หรือไม่?",
            buttonCancel: "ไม่ใช่",
            buttonSubmit: "ใช่"
          },
          confirm: this.sendRating
        },
        generalDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "",
            detail: "",
            buttonCancel: ""
          }
        }
      },
      showScanner: false
    };
  },
  created() {
    if (!this.article.articlesId) {
      this.getArticle(this.articleId);
      this.getRatingNotificationStatus();
    }
  },
  computed: {
    pickMethod() {
      if (
        this.privilege.quota &&
        this.selection.length > this.privilege.quota
      ) {
        return "random";
      }

      return "manual";
    },
    filterSearchData() {
      return this.data;
    },
    displaySelection() {
      if (localStorage.getItem("adminRole") === "3") {
        return false;
      }

      if (this.data && this.article && this.article.privilege) {
        return (
          this.article.privilege.type === PRIVILEGE.TYPE.REGISTER &&
          this.data.filter(
            row => row.type === USER_PRIVILEGE_REGISTER.TYPE.PICKED
          ).length < 1
        );
      }

      return false;
    },
    displayPublishButton() {
      if (
        this.activeTab === "processedList" &&
        this.data &&
        this.data.length > 0
      ) {
        return this.data.filter(row => row.code !== null).length < 1;
      }

      return false;
    },
    displayScanButton() {
      if (
        this.activeTab === "usageList" &&
        this.privilege.usageType !== "REDEEM" &&
        this.data.length > 0
      ) {
        return true;
      }

      return false;
    }
  },
  watch: {
    activeTab() {
      const vm = this;
      if (
        vm.article.articlesId &&
        vm.article.privilege &&
        vm.article.privilege.type
      ) {
        vm.getAttendances(this.article.privilege.type);
      }
    }
  },
  methods: {
    rowClassName({ row, rowIndex }) {
      const searchText = this.searchText;
      const shouldSearch = this.searchText.length > 0;

      const isInSearchCriteria = shouldSearch
        ? row.fullname.includes(searchText) ||
          (row.code && row.code.includes(searchText))
        : true;
      const isSelected = this.selection
        .map(({ userPrivilegeRegisterId }) => userPrivilegeRegisterId)
        .includes(row.userPrivilegeRegisterId);
      const shouldShow = this.showOnlySelected
        ? isInSearchCriteria && isSelected
        : isInSearchCriteria;

      return shouldShow ? "" : "hidden";
    },
    async getArticle(articleId) {
      const article = await axios.get(
        `${process.env.HOST}/api/admin/articles/${articleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`
          }
        }
      );

      this.article = article.data;
      this.$emit("loaded", article.data);

      if (
        this.article.articlesId &&
        this.article.privilege &&
        this.article.privilege.type
      ) {
        this.getAttendances(this.article.privilege.type);
      }
    },
    getAttendances(articlePrivilegeType) {
      const type = this.resolveAttendeeStatus(this.activeTab);
      const format = this.preferredFormat || "json";

      if (articlePrivilegeType === PRIVILEGE.TYPE.IMMEDIATE) {
        this.getAttendancesByType("immediated", { format });
      } else if (articlePrivilegeType === PRIVILEGE.TYPE.REGISTER) {
        this.getAttendancesByType("registered", {
          attendeeStatus: type,
          format
        });
      }
    },
    async getAttendancesByType(
      privilegeType = null,
      { attendeeStatus = null, format = null }
    ) {
      this.data = [];
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/${privilegeType}`;
      const params = {
        params: {
          type: attendeeStatus,
          format
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };

      const articlePrivilege = await axios.get(url, params);

      this.privilege = articlePrivilege.data.privilege;
      this.data = articlePrivilege.data.list;
    },
    async getRatingNotificationStatus() {
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/rating/status`;
      const params = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };

      const status = await axios.get(url, params);

      this.rating = status.data;
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    resolveAttendeeStatus(tab) {
      if (["processedList", "usageList"].indexOf(tab) >= 0) {
        return USER_PRIVILEGE_REGISTER.TYPE.PICKED;
      }

      return null;
    },
    async exportList() {
      let privilegeType;
      if (this.privilege.type === PRIVILEGE.TYPE.IMMEDIATE) {
        privilegeType = "immediated";
      } else {
        privilegeType = "registered";
      }

      const exportUrl = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/${privilegeType}`;
      const params = {
        params: { format: "xlsx" },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        },
        responseType: "blob"
      };

      const exported = await axios.get(exportUrl, params);
      const blob = new Blob([exported.data], {
        type: "application/octet-stream"
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `list-${this.article.title}-exported.xlsx`;
      link.click();
    },
    async exportCode() {
      const exportUrl = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/codes`;
      const params = {
        params: { format: "csv" },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        },
        responseType: "arraybuffer"
      };

      const exported = await axios.get(exportUrl, params);
      const blob = new Blob([exported.data], {
        type: "application/octet-stream"
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `code-${this.article.title}-exported.xls`;
      link.click();
    },
    async pickSelection(confirm) {
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/random`;
      const data = {
        registerIds: this.selection.map(
          register => register.userPrivilegeRegisterId
        )
      };
      const params = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };
      if (confirm === true) {
        try {
          await axios.post(url, data, params);
          this.setGeneralDialog(
            "คัดเลือกผู้โชคดีสำเร็จ",
            "โดยรายชื่อผู้ที่ถูกคัดเลือกจะอยู่ในแท็บ <strong>รายชื่อผู้โชคดี</strong>",
            "ปิด"
          );
          this.getAttendances(this.article.privilege.type);
        } catch (error) {
          this.setGeneralDialog("พบข้อผิดพลาด", error.message, "ปิด");
        }
      }

      this.dialogs.pickSelectionDialog.isShow = false;
    },
    updateCode(code) {
      const data = this.data;
      const output = data.find(item => item.code === code);

      if (output) {
        this.setRequestCode(output);
      } else {
        this.setGeneralDialog(
          "ไม่พบโค้ดนี้ในรายชื่อ",
          `กรุณาตรวจสอบโค้ดที่อ่านค่าได้อีกครั้ง<br><br>ว่า <b>${code}</b> อยู่ในรายชื่อหรือไม่?<br><br>
          หากพบว่าโค้ดนี้อยู่ในรายชื่อ กรุณาลองสแกนใหม่อีกครั้งครับ`,
          "ปิด"
        );
      }
    },
    setRequestCode(data) {
      this.dialogs.useCodeDialog.picked = data;
      this.dialogs.useCodeDialog.data.detail = `${data.fullname ||
        "-"}<br><br>เบอร์โทร ${data.mobileNumber || "-"}<br>
        อีเมล ${data.email || "-"}<br>ลงทะเบียนวันที่ ${moment(
        data.createdAt
      ).format("DD-MM-YYYY HH:mm")}<br><br>
        รหัส <strong>${data.code}</strong>`;
      this.dialogs.useCodeDialog.isShow = true;
    },
    async useCodeRequest(confirm) {
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/join`;
      let data = {};
      const params = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };

      const picked = this.dialogs.useCodeDialog.picked;
      if (picked) {
        data = {
          codeId: picked.codeId
        };
      }

      if (confirm === true && data.codeId) {
        try {
          await axios.post(url, data, params);

          this.setGeneralDialog(
            "ใช้โค้ดสำเร็จ",
            `โค้ด <strong>${picked.code}</strong> ถูกใช้แล้ว`,
            "ตกลง"
          );
          this.getAttendances(this.article.privilege.type);
        } catch (error) {
          this.setGeneralDialog("พบข้อผิดพลาด", error.message, "ปิด");
        }
      }
      this.dialogs.useCodeDialog.isShow = false;
    },
    showUseCodeButton() {
      return (
        this.privilege.type === PRIVILEGE.TYPE.REGISTER &&
        this.privilege.usageType === PRIVILEGE.USAGE_TYPE.ACTIVITY
      );
    },
    async sendNotification(confirm) {
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/attendee/publish`;
      const params = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };

      if (confirm === true) {
        try {
          const result = await axios.post(url, {}, params);
          if (result) {
            this.setGeneralDialog(
              "ยืนยันการแจ้งผล",
              "การแจ้งผลของคุณสำเร็จแล้ว<br>ผู้โชคดีจะได้รับรหัสตามการตั้งค่าที่คุณได้กำหนดไว้",
              "ตกลง"
            );
            this.getAttendances(this.article.privilege.type);
          }
        } catch (error) {
          this.setGeneralDialog("พบข้อผิดพลาด", error.message, "ปิด");
        }
      }

      this.dialogs.sendNotificationDialog.isShow = false;
    },
    async sendRating(confirm) {
      const url = `${process.env.HOST}/api/admin/articles/${
        this.articleId
      }/rating/send`;
      const params = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`
        }
      };

      if (confirm === true) {
        try {
          const result = await axios.post(url, {}, params);
          if (result) {
            this.setGeneralDialog(
              "การแจ้งส่งแบบประเมินสำเร็จ",
              "การแจ้งส่งแบบประเมินสำเร็จ<br>ผู้เข้าร่วมที่ใช้งานโค้ดไปแล้วจะได้รับแบบประเมินทางแอปพลิเคชัน",
              "ตกลง"
            );
          }
        } catch (error) {
          this.setGeneralDialog("พบข้อผิดพลาด", error.message, "ปิด");
        }
      }

      this.dialogs.sendRatingDialog.isShow = false;
    },
    openScanner() {
      this.showScanner = true;
    },
    setGeneralDialog(title, desc, button) {
      this.dialogs.generalDialog.data.title = title || "Title";
      this.dialogs.generalDialog.data.detail = desc || "message";
      this.dialogs.generalDialog.data.buttonCancel = button || "OK";
      this.dialogs.generalDialog.isShow = true;
    }
  }
};
</script>

<style lang="scss">
.hidden {
  display: none;
}

pre {
  color: inherit;
  margin: 0;
  white-space: pre-line;
}
.el-popover {
  font-family: "Sukhumvit Tadmai";
  color: #8c8786;

  p {
    font-size: 12px;
  }
}
#datatable {
  background-color: $white;
  height: calc(100vh - 110px);

  .el-table {
    .el-table__body-wrapper {
      overflow-y: scroll;
      padding-top: 49px;
      max-height: 100%;
    }
    .name-wrapper {
      i {
        font-size: 20px;
      }
    }
    thead {
      color: $black;
    }
  }

  .attendee-list {
    flex-grow: 1;
    flex-basis: 0;
  }
  .summary-bar {
    flex-grow: 0;
    flex-basis: 88px;
    padding: 24px;

    .summary-items {
      text-align: left;
      align-self: center;

      &.button-wrapper {
        padding-left: 16px;
        border-left: 1px solid #e0e0e0;

        button {
          margin-left: 16px;
        }
      }

      .item {
        margin-right: 24px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    small {
      font-size: 11px;
      font-weight: 500;
      line-height: 1.64;
      letter-spacing: -0.1px;
      color: #8c8786;
    }
    label {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.29;
      letter-spacing: -0.1px;
      color: $black;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/attendance/list.vue